import type { FeaturedJob, FeaturedMedia } from 'rwl-shared/dist/models';

export type SerializedMedia = Pick<
    FeaturedMedia,
    'id' | 'type' | 'thumbnailUrl' | 'sourceUrl' | 'sortOrder'
>;

export const serializeMedia = (job: FeaturedJob): SerializedMedia[] =>
    sortedMedia(
        (job.media || []).map((media) => ({
            id: media.id,
            type: media.type,
            thumbnailUrl: media.thumbnailUrl,
            sourceUrl: media.sourceUrl,
            sortOrder: media.sortOrder,
            isCover: media.isCover,
        }))
    );

export const sortedMedia = <T extends { sortOrder: number; isCover?: boolean }>(
    media: T[]
): T[] =>
    [...media].sort((a, b) => {
        if (a.isCover) return -1;
        if (b.isCover) return 1;
        return a.sortOrder - b.sortOrder;
    });
